export const matterForContentProductCards = [
	{
		icon: '🔹',
		subtitle: 'matterForContent_subtitle1',
	},
	{
		icon: '🔹',
		subtitle: 'matterForContent_subtitle2',
	},
	{
		icon: '🔹',
		subtitle: 'matterForContent_subtitle3',
	},
	{
		icon: '🔹',
		subtitle: 'matterForContent_subtitle4',
	},
	{
		icon: '🔹',
		subtitle: 'matterForContent_subtitle5',
	},
];
